module.exports = __webpack_public_path__ + "img/daesa-logo-blanco.70161f0f.png";